<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="170"
    offset-y
  >
    <template #activator="{ on }">
      <v-btn icon v-on="on">
        <v-badge
          color="accent"
          :value="count"
          :content="count"
          class="theme--light"
          overlap
        >
          <v-icon size="24">
            mdi-bell
          </v-icon>
        </v-badge>
      </v-btn>
    </template>

    <v-list min-width="300px">
      <v-list-item v-for="notification in notifications" :key="notification.id">
        <v-list-item-content>
          <v-list-item-title>{{ notification.data.title }}</v-list-item-title>
          <v-list-item-subtitle>{{ notification.data.body }}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action class="subtitle-2 font-weight-light">
          {{ notification.data.created_at }}
        </v-list-item-action>
      </v-list-item>
      <v-list-item v-if="!count">
        <v-card width="100%" class="elevation-0">
          <v-card-text class="text-center">
            <v-icon size="64">
              mdi-bell-off
            </v-icon>
          </v-card-text>
          <v-card-text class="text-center">
            No Notifications
          </v-card-text>
        </v-card>
      </v-list-item>
      <v-divider />
      <!-- <inertia-link class="v-list-item v-list-item--link v-list-item--dense theme--light" :href="route('notification.index')" replace @click="menu = false">
        <v-list-item-icon>
          <v-icon color="primary">
            mdi-wrench
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>All Notifications</v-list-item-title>
        </v-list-item-content>
      </inertia-link> -->
    </v-list>
  </v-menu>
</template>
<script>
export default {
   components: {
      //
   },
   props: {
      //
   },

   data: () => ({
      menu: false
   }),

   computed: {
      notifications () {
         return this.$page.props.unread_notifications
      },
      count () {
         return this.$page.props.unread_notifications.length
      }
   },

   mounted () {
      // this.$echo.private('users.' + this.$page.props.auth.user.id).notification((notification) => {
      //   this.$page.props.notifications.push({ data: notification })
      // })
   },

   methods: {
      hasPermission () {
         return true
      }
   }
}
</script>
